import { navigate } from 'gatsby';

import { _ } from './l10n';
import { ButtonSizes, ButtonTypes } from '../consts/button';
import { ButtonProps } from '../components/generic/Button';

export const getContactButtonProps = (isHomePage?: boolean, isXSScreen?: boolean): ButtonProps => ({
  label: _('Contact us'),
  mode: isHomePage ? ButtonTypes.INVERTED : ButtonTypes.PRIMARY,
  onClick: () => navigate('/contact/'),
  size: isXSScreen ? ButtonSizes.SMALL : ButtonSizes.MEDIUM,
});
